import { Link } from 'react-router-dom';
import activeArrow from '../../assets/icons/LayoutIcons/short-arrow.svg';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DropDownItem = (props: any) => {
  return (
    <Link
      className={`cursor-pointer ${props.item.disabled && 'disabled'}`}
      to={`${props.href || location.pathname} `}
    >
      <div className='flex'>
        {location.pathname.includes(props.item.href) && (
          <img src={activeArrow} alt={activeArrow} className='w-[10px]' />
        )}

        <div
          className={`${location.pathname.includes(props.item.href) ? 'pl-[10px]' : 'pl-[15px]'}`}
        >
          <span
            title={props.item.title}
            className={`leading-[22px] py-[9px] flex-1
                      nav-hover ${
                        location.pathname.includes(props.item.href) ? 'active !font-medium' : ''
                      }
                      font-normal text-green text-[14px] font-poppins flex items-center justify-between `}
          >
            {props.item.title}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default DropDownItem;
